import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ProblemSolution from './components/ProblemSolution';
import CustomerSegments from './components/CustomerSegments';
import Footer from './components/Footer';
import Contact from './components/Contact';
import Industries from './components/Industries';
import Solution from './components/Solution';
import KeyFeatures from './components/KeyFeatures';
import API from './components/API';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import ScrollToTop from './components/ScrollToTop';

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route
            path="/"
            element={
                <main>
                <HeroSection />
                <ProblemSolution />
                <KeyFeatures />
                <CustomerSegments />
                </main>
            }
          />
          <Route path="/contact" element={<Contact />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/solution" element={<Solution />} />
          <Route path="/api" element={<API />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
